export const state = {
    customers: [],
    systemCustomer: []
}
export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/customers/state.js